export default __webpack_public_path__ + "static/background-form-bb49ec0ccf488d22281f84212e4eb001.svg";